window.addEventListener('DOMContentLoaded', function() {
  $('.products.show .show-included-files').click(function () {
    $(this).addClass('hide')
    $('.included-files').addClass('show')
    return false
  })
})
